import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import Cookies from 'js-cookie';
import { useParams } from "react-router-dom";
// import { launchAgoraClassroom } from "../../services/Utils/agoraUtils";
// import { agoraSessionEnd } from "./AgoraCommon";


const JoinSession = () => {
  // const { uid, channelName, classType, roleId, name } = useParams();
  // const { Translation } = useSelector((state) => ({
  //   Translation: state.Translation.translation?.Settings || {},
  // }));
    
//   const agoraCallDuration = Translation?.AgoraCallDurationForCourse;
//   const questionId =  sessionStorage.getItem('QuestionID');
//   const sessionId = questionId;
//   const userInfo = Cookies.get('userInfo') ? JSON.parse(Cookies.get('userInfo')) : null;
//   const profileInfo = Cookies.get("ProfileInfo") ? JSON.parse(Cookies.get("ProfileInfo")): null;
//   const rtmToken = JSON.parse(localStorage.getItem("rtmToken"));
//   const roomName = `room${questionId}`;
//   const roomUuid = `roomuuid${questionId}`;
//   const channel = `channel${questionId}`;
//   const roomType = 0;
//   const sessionType = 1;
//   const userUid = userInfo?.uid;
//   const userName = profileInfo?.UserName;
//   const pathName = sessionStorage.getItem("pathName");


  useEffect(() => {
    document.getElementById('root').style.display = 'none';
    document.getElementById('root-whiteboard').style.display = 'block';
    // window.location.href = "/join-room/oocaMjWWXZUFK9dbPyoNpCjApYE12/channel_s423_b1/QC/2/John%20Doe"
    // console.log('window: ', window);
    // window.Whiteboard.mount(document.getElementById('root-main'), {
    //   route: '/whiteboard/abc123'
    // });
    // localStorage.setItem("SessionType", "S");
    // localStorage.setItem("CallType", 1);
    // const params = { userUid, userName, roomUuid, sessionId, roomName, channel, rtmToken, roomType, sessionType, pathName, agoraCallDuration, agoraSessionEnd };
  }, []);
  return;
};
export default JoinSession;
